import { ApplicationConfig, isDevMode } from '@angular/core';
import {
  InMemoryScrollingFeature,
  InMemoryScrollingOptions,
  provideRouter,
  withInMemoryScrolling,
} from '@angular/router';

import { routes } from './app.routes';
import { provideClientHydration } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { ActionReducerMap, provideStore } from '@ngrx/store';
import { provideRouterStore } from '@ngrx/router-store';
import { provideEffects } from '@ngrx/effects';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { DialogService } from 'primeng/dynamicdialog';
import { dialogReducer } from './core/state/dialogs/dialog.reducer';
import { DialogEffects } from './core/state/dialogs/dialog.effects';
import {
  provideHttpClient,
  withFetch,
  withInterceptors,
} from '@angular/common/http';
import { graphqlProvider } from './graphql.provider';
import { provideServiceWorker } from '@angular/service-worker';
import { mainInterceptor } from './shared/interceptors/main-interceptor';
import { MessageService } from 'primeng/api';
import { VehicleTypeService } from './shared/services/vehicle-type.service';
import { SelectedModificationService } from './shared/services/selected-modification.service';
// Configure scroll behavior.
const scrollConfig: InMemoryScrollingOptions = {
  scrollPositionRestoration: 'enabled', // Set to 'top' to always scroll back to the top.
  anchorScrolling: 'enabled', // Enable anchor scrolling if needed.
};

// Create an in-memory scrolling feature.
const inMemoryScrollingFeature: InMemoryScrollingFeature =
  withInMemoryScrolling(scrollConfig);

const reducers: ActionReducerMap<any> = {
  dialogs: dialogReducer,
};

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes, inMemoryScrollingFeature),
    provideClientHydration(),
    provideAnimations(),
    provideStore(reducers),
    provideRouterStore(),
    provideEffects([DialogEffects, DialogService]),
    provideStoreDevtools({ maxAge: 25, logOnly: !isDevMode() }),
    MessageService,
    provideHttpClient(withFetch(), withInterceptors([mainInterceptor])),
    graphqlProvider,
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000',
    }),
  ],
};
